import { Expose, plainToClass } from 'class-transformer';

import { TooltipPosition } from '@angular/material/tooltip';

import { Default, ExposeFunction } from '@lib/common/decorators';

import { SnTooltipConfig } from '../types/tooltip-config.type';
import { SnTooltipDisableExpression } from '../types/tooltip-disable-expression.type';

export class SnTooltip {
  @Expose()
  public message: string;

  @Expose()
  @Default('below')
  public position: TooltipPosition;

  @Expose()
  @Default(0)
  public showDelay: number;

  @Expose()
  @Default(0)
  public hideDelay: number;

  @ExposeFunction()
  public disabled: SnTooltipDisableExpression;

  public static fromConfig(config: SnTooltipConfig): SnTooltip {
    const data = typeof config === 'string' ? { message: config } : config;

    return plainToClass(SnTooltip, data, { strategy: 'excludeAll' });
  }

  constructor() {}
}
